import type { BN } from "@coral-xyz/anchor";

export function bnToNumber(bn: BN): number {
  const result = bn.abs();

  let number = result.toNumber();

  if (bn.isNeg()) {
    number = -number;
  }

  return number;
}
